// extracted by mini-css-extract-plugin
export var chevronIcon = "_e0-2";
export var teamName = "_e0-1";
export var teamSwitcherButton = "_e0-0";